<template>
  <div class="sample_card__container col-md-6 col-xl-5">
    <div class="card__head">
      <span class="fs-w">ABSXP24010001-1-1</span>
      <span class="tag">待处理</span>
    </div>
    <div class="card__body">
      <div class="img__container">
        <el-image
          :src="
            'https://abs-oss.oss-cn-shanghai.aliyuncs.com/202209%2F628875cf7d3d22828df0345e7a1bc8de.jpg' ||
            '/image/static/img/nopic.jpg'
          "
          :preview-src-list="[
            'https://abs-oss.oss-cn-shanghai.aliyuncs.com/202209%2F628875cf7d3d22828df0345e7a1bc8de.jpg' ||
              '/image/static/img/nopic.jpg',
          ]"
          style="width: 99px; height: 65px"
          fit="cover"
        >
          <div slot="error" class="image-slot">
            <img
              src="/image/static/img/nopic.jpg"
              style="width: 99px; height: 65px"
            />
          </div>
        </el-image>
      </div>
      <div class="sample-base__container">
        <div class="color-info">红白色 Red/White</div>
        <div class="number-fty__price">
          <div>
            <span class="label-key">数量：</span>
            <span class="fs-18 color-info">2</span>
          </div>
          <div>
            <span class="label-key">工厂报价：</span>
            <span class="fs-18 fs-600w color-blue mr-3px">10.99</span>
            <span class="fs-12 color-info">CNY</span>
          </div>
        </div>
        <div
          style="
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 1;
            -webkit-box-orient: vertical;
          "
        >
          <span class="fs-w color-4f"> 苏州合祥纺织科技有限公司 </span>
        </div>
      </div>
    </div>
    <div class="card__footer">
      <div class="card__footer__wrapper">
        <div>
          <span class="fs-w">需求日期：</span>
          <span class="fs-w" style="color: #101010">2024-01-10</span>
        </div>
        <div>
          <span class="fs-w">完成日期：</span>
          <span class="fs-w" style="color: #101010">2024-01-10</span>
        </div>
      </div>
      <div class="card__footer__wrapper">
        <div>
          <span class="fs-w">收到日期：</span>
          <span class="fs-w" style="color: #101010">2024-01-19</span>
        </div>
        <div>
          <span class="fs-w">打样结果：</span>
          <span :class="'tag tag-type--'">样品合格</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    cardInfo: { type: Object, default: () => {} },
  },
}
</script>
<style lang="scss" scoped>
.sample_card__container {
  max-width: 413px;
  min-width: 350px;
  height: 170px;
  margin-bottom: 10px;
  margin-left: 10px;
  border-radius: 5px;
  background-color: #ffffff;
  .card__head {
    border-radius: 5px 5px 0px 0px;
    background-color: #f9f9f9;
    height: 30px;
    padding: 10px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .card__body {
    height: calc(100% - 86px);
    padding: 10px;
    display: flex;
    .img__container {
      border-radius: 5px;
      margin-right: 10px;
      .el-image {
        border-radius: 5px;
      }
    }
    .sample-base__container {
      display: flex;
      flex: 1;
      flex-direction: column;
      .color-info {
        color: #101010;
        font-weight: 600;
      }
      .number-fty__price {
        display: flex;
        justify-content: space-between;
      }
    }
  }
  .card__footer {
    height: 44px;
    margin-bottom: 10px;
    padding: 0 10px;
    display: flex;
    justify-content: space-between;
    .card__footer__wrapper {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      > div:first-child {
        margin-bottom: 5px;
      }
    }
  }
}
.fs-w {
  color: #6c757d;
  font-weight: 600;
  font-size: 14px;
}
.color-4f {
  color: #4f4f4f;
}
.mb-5px {
  margin-bottom: 5px;
}
.mb-10px {
  margin-bottom: 10px;
}
.mb-30px {
  margin-bottom: 30px;
}
.mr-3px {
  margin-right: 3px;
}
.label-key {
  color: #6c757d;
  font-weight: 600;
}
.fs-18 {
  font-size: 18px;
}
.color-blue {
  color: #007bff;
}
.fs-12 {
  font-size: 12px;
}
.fs-600w {
  font-weight: 600;
}
@media screen and (min-width: 768px) {
  .col-md-6 {
    flex: 0 0 50%;
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
}
@media screen and (min-width: 1200px) {
  .col-xl-5 {
    flex: 0 0 41.666667%;
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
}
.tag {
  padding: 2px 17px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 600;
  background-color: #efefef;
  color: #4f4f4f;
}
</style>
